<template>
  <ion-page>
    <Toolbar
      :title="t('hzba.pdf.vorschauTitel')"
      show-back-button
      @onBackButtonClicked="() => {}"
    >
      <template #leading>
        <ion-buttons slot="start">
          <ion-button @click="$router.replace(goBackUrl)">
            <ion-icon slot="icon-only" :icon="arrowBack" />
          </ion-button>
        </ion-buttons>
      </template>

      <template #trailing>
        <ion-buttons slot="primary">
          <ion-button
            slot="end"
            color="light"
            :disabled="isDownloading"
            @click="downloadPdf"
          >
<!--            {{-->
<!--              !isDownloading-->
<!--                ? t("hzba.buttons.downloaden")-->
<!--                : "pdf wird erstellt..."-->
<!--            }}-->

            <ion-icon v-if="!isDownloading" slot="icon-only" :icon="canShare ? share : download" />
            <ion-spinner v-else color="light"></ion-spinner>
          </ion-button>
        </ion-buttons>
      </template>
    </Toolbar>
    <ion-content>
      <PdfPageSkeleton v-if="!isHzbaLoaded" />
      <PdfPreviewerAndCreator
        v-else
        ref="pdfViewer"
        :download-name="`${immobilie?.strasse}_${immobilie?.plz}_${immobilie?.stadt}_vorschau.pdf`"
        :go-back-url="goBackUrl"
        @download-completed="isDownloading = false"
        :immobilieId="immobilie.id"
      >
        <pdf-templates :ba="ba" :immobilie="immobilie" />
      </PdfPreviewerAndCreator>
    </ion-content>
  </ion-page>
</template>

<script>
import { download, share } from 'ionicons/icons';
import { useI18n } from "vue-i18n";
import { arrowBack } from "ionicons/icons";
import {
  IonPage,
  IonIcon,
  IonButton,
  IonButtons,
    IonSpinner,
  IonContent,
  onIonViewDidLeave,
  onIonViewWillLeave,
  toastController,
} from "@ionic/vue";
import PdfPreviewerAndCreator from "@/components/Pdf/PdfPreviewerAndCreator";
import PdfHzbaPreview from "@/components/Pdf/Bericht_Heizung/PdfHzbaTemplate";
import { onIonViewWillEnter } from "@ionic/vue";
import { useStore } from "@/composables/useTypedStore";
import { computed, nextTick, ref, watch } from "vue";
import PdfHzbaTemplate from "@/components/Pdf/Bericht_Heizung/PdfHzbaTemplate";
import Immobilie from "@/models/immobilie.model";
import Toolbar from "@/components/Navigation/Toolbar";
import PdfPageSkeleton from "@/components/PdfPageSkeleton";
import useBestandsaufnahmeSubpage from "@/composables/Bestandsaufnahme/useBestandsaufnahmeSubpage";
import PdfTemplates from "@/components/Pdf/PdfTemplates";
import { useRouter } from "vue-router";
import useDownloadHelper from "@/composables/useDownloadHelper";

export default {
  name: "PdfPreview",
  components: {
    PdfTemplates,
    PdfPageSkeleton,
    Toolbar,
    IonIcon,
    IonButtons,
    IonSpinner,
    IonButton,
    PdfHzbaTemplate,
    PdfHzbaPreview,
    IonContent,
    PdfPreviewerAndCreator,
    IonPage,
  },
  setup() {
    const { t, locale } = useI18n({ useScope: "global" });
    const pdfViewer = ref();
    const store = useStore();
    const router = useRouter();
    const isDownloading = ref(false);

    const { canShare } = useDownloadHelper();

    const { isHzbaLoaded, ba, goBackUrl } = useBestandsaufnahmeSubpage({
      onIonViewWillEnter,
      onIonViewWillLeave,
    });

    // console.log("ba.value.status:", ba.value.status);
    // console.log(
    //   "ba.value.technProjektsteuerungName:",
    //   ba.value.technProjektsteuerungName
    // );

    watch(
      () => isHzbaLoaded.value,
      async (newVal, oldVal) => {
        if (newVal && newVal !== oldVal) {
          if (!ba.value.hasPdfSupport()) {
            const toast = await toastController.create({
              message: t("hzba.pdf.pdfErstellungNichtSupported"),
              duration: 2000,
            });
            await toast.present();

            await router.replace(goBackUrl.value);
          }
        }
      }
    );

    const immobilie = computed(() => {
        return Immobilie.getters('getPropOrFallbackProp')( ba.value.immobilie );
    });

    const downloadPdf = async () => {
      isDownloading.value = true;
      await nextTick();

      await pdfViewer.value.downloadPdf();
      // isDownloading.value = false;

      await nextTick();
      setTimeout(async () => {
        await pdfViewer.value.generatePdf();
        // isDownloading.value = false;
      }, 100);
    };

    return {
      ba,
      arrowBack,
      immobilie,
      canShare,
      isHzbaLoaded,
      downloadPdf,
      share, download,
      pdfViewer,
      goBackUrl,
      isDownloading,
      t,
    };
  },
};
</script>

<style scoped>
</style>